<template>
  <div class="page" id="page_w">
    <template v-if="!actInfo">
      <div class="error_tips">
        活动已结束
      </div>
    </template>
    <template v-else-if="actInfo.tips">
      <div class="error_tips">
        {{ actInfo.tips }}
      </div>
    </template>
    <template v-else>
      <!-- 游戏账号绑定 - 新界面 -->
      <BindAccountDialog
        ref="bindAccountRef"
        :isCommon="false"
        :actId="actId"
        @update="handleFetchUserInfo"
      />
      <!-- 头图 & 一些信息 -->
      <div class="header" id="header">
        <img :src="gameDetail.head_image" />
        <!-- 活动会场列表 -->
        <div class="games_wrap">
          <div class="game_list">
            <div
              v-for="gIt in gameList"
              :key="gIt.register_draw_game_id"
              class="game_item"
              :class="{ active: gIt.register_draw_game_id === curGameId }"
              @click="handleChangeGame(gIt)"
            >{{ gIt.register_draw_game_name }}</div>
          </div>
        </div>
        <!-- 悬浮功能 -->
        <div class="float">
          <div class="float_item float_rule" @click="handleShowRule">活动规则</div>
          <div class="float_item float_record" @click="handleOpenRecord">中奖记录</div>
        </div>
        <div class="download_btn">
          <!-- 绑定账号 -->
          <div v-if="bindingAccount" class="binding_account mb_12" style="color: #fff; white-space: nowrap">
            已绑定账号: {{ bindingAccount }}
            <!-- <span class="account color_link" @click="onLogswitch">切换账号</span> -->
          </div>
          <img :src="CDN_URL + '/download.png'" alt="" @click="handleHeaderDownload">
        </div>
      </div>
      <div class="content">
        <!-- 注册好礼 -->
        <div class="register_wrap ctx_wrap">
          <div class="ctx_title">
            <img :src="CDN_URL + '/title1.png'" />
          </div>
          <div class="ctx_main">
            <div
              class="register_main bg_cover"
              :style="{
                backgroundImage: `url(${CDN_URL + '/register_bg.png'})`,
                backgroundSize: `100% 100%`,
              }"
            >
              <img :src="gameDetail.register_welfare.register_welfare_image" />
            </div>
            <div
              class="receive_btn"
              :class="{ receive_done: gameDetail.register_welfare.can_get === 0 }"
              @click="handleReceive"
            >
              <img :src="CDN_URL + '/receive.png'" alt="">
              <div class="receive_btn_text ab_center bold fs_16">{{ gameDetail.register_welfare.can_get === 1 ? '一键领取' : '已领取' }}</div>
            </div>
          </div>
        </div>
        <!-- 新手好礼 抽奖 -->
        <div class="draw_wrap ctx_wrap">
          <div class="ctx_title">
            <img :src="CDN_URL + '/title2.png'" />
          </div>
          <!-- 跑马灯中奖名单广播 -->
          <div class="marquee">
            <img src="//image.hzwxbz2.cn/java-yunying/jyy_1724381884933_3eb855483503679c8dba2a8f97c87208.png" alt="">
            <div class="view">
              <div class="cont">
                <p class="run" v-for="(item, index) in marqueeList" :key="index">
                  {{ `恭喜${item.userName}获得${item.name}` }}
                </p>
              </div>
            </div>
            <div class="gift-detail" @click="handleShowGiftDetail">奖励详情</div>
          </div>
          <div class="tips" :class="{ 'tips_main_line_2': slogan.includes('\n') }">
            <div class="tips_main" v-html="slogan"></div>
          </div>
          <div class="ctx_main">
            <div class="draw_container">
              <LuckyGrid
                ref="luckyGrid"
                width="4.2533rem"
                height="4.1333rem"
                :rows="3"
                :cols="3"
                :prizes="prizes"
                :buttons="buttons"
                v-bind="extraAttrs"
                @start="onluckyStart"
                @end="onluckyEnd"
              />
            </div>
            <!-- 任务列表 -->
            <div class="task_list">
              <div
                v-for="tIt in getFieldInDetail('task_list')"
                :key="tIt.id"
                class="task_item"
              >
                <div class="task_label">
                  <div class="task_title">
                    <span>{{ tIt.name }}</span>
                    <a v-if="tIt.condition_type == 4" @click="handleShare(tIt.id)">去分享</a>
                  </div>
                  <div class="task_feed">抽奖机会+{{ tIt.draw_count }}</div>
                </div>
                <div class="task_btn">
                  <van-button
                    size="small"
                    :color="tIt.is_done === 1 ? '#878787' : '#E93F11'"
                    round
                    style="width: 88px"
                    :disabled="tIt.is_done === 1"
                    @click="handleReceiveReward(tIt)"
                  >{{ tIt.is_done === 1 ? '已领取' : '领取' }}</van-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 游戏介绍 -->
        <div class="game_intro ctx_wrap">
          <div class="ctx_title">
            <img :src="CDN_URL + '/title3.png'" />
          </div>
          <div class="ctx_main">
            <!-- 游戏的精彩镜头 -->
            <div class="game_video">
              <div v-if="getFieldInDetail('video')[0]" class="player_contain gold_border">
                <VideoPlayer
                  width="4.494rem"
                  height="2.52rem"
                  :icons="icons"
                  fitVideoSize="fixWidth"
                  key="1"
                  :url="getFieldInDetail('video')[0]"
                />
              </div>
            </div>
            <!-- 轮播图 -->
            <div class="game_swiper">
              <div class="swipe_wrap gold_border mb_8">
                <van-swipe
                  autoplay="5000"
                  :show-indicators="false"
                  style="width: 100%; height: 100%;"
                  @change="handleSwipeChange"
                >
                  <van-swipe-item
                    v-for="(i, iIdx) in getFieldInDetail('banner')"
                    :key="iIdx"
                    class="swipe_item bg_contain"
                    :style="{
                      backgroundImage: `url(${i})`
                    }"
                  ></van-swipe-item>
                </van-swipe>
              </div>
              <div class="custom-indicator">
                <div
                  v-for="(i, iIdx) in getFieldInDetail('banner')"
                  :key="iIdx"
                  class="indi_item"
                  :class="{ 'indi_active': iIdx === curActiveSwipteItem }"
                >
                  <div class="indi_dot"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 更多福利 -->
        <div class="more_wel ctx_wrap">
          <div class="ctx_title">
            <img :src="CDN_URL + '/title4.png'" />
          </div>
          <div class="ctx_main" style="margin-top: 6px; padding: 0 4px">
            <div
              v-for="(i, iIdx) in getFieldInDetail('ad_list')"
              :key="iIdx"
              class="wel_img gold_border"
              @click="handleOpenNewPage(i.jump_url)"
            >
              <img :src="i.resource_url" />
            </div>
          </div>
        </div>
      </div>
      <div v-show="showBottonLine" class="bottom_btn">
        <div v-if="showBindBtn" class="btn_item btn_binding" @click="handldShowBinding">绑定账号</div>
        <div class="btn_item btn_download" @click="handleBotBtnClick">下载游戏</div>
      </div>
      <van-popup
        v-model="showRecord"
        round
        position="bottom"
        :style="{ height: '80%' }"
      >
        <Record :list="recordList" :recordFetched="recordFetched" />
      </van-popup>
      <van-popup 
        v-model="showGiftDetail"
        @closed="giftDetailCloseReport"
        round
        position="bottom"
        :style="{ height: '60%' }"
      >
        <div class="gift-detail-item">
          <div class="gift-title">奖励详情</div>
          <div class="gift-list">
            <div class="gift-item" v-for="(item, index) in getFieldInDetail('lottery_list')" :key="index">
              <p>版位{{ index + 1 }}</p>
              <div class="gift-info">
                <img :src="item.icon" />
                <div>
                  <div class="gift-name">{{ item.name }}</div>
                  <div class="gift-desc">{{ item.description }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="gift-btn">
            <button @click="showGiftDetail = false">去抽奖</button>
          </div>
        </div>
      </van-popup>
      <Popup
        :visible.sync="visible"
        v-bind="feedback"
        :headerStyle="{
          background: '#FFCA68'
        }"
        confirmButtonColor="#E46432"
        cancelButtonColor="#9D9D9D"
        @confirm="feedback.onSure"
        @cancel="feedback.onCancel"
      >
        <template v-if="feedbackType === 0">
          <div class="rule_wrap" v-html="actInfo.rule"> 
          </div>
        </template>
        <template v-if="[3, 4].includes(feedbackType)">
          <div class="d_flex_col flex_center mb_16" v-if="feedbackType === 4">
            <img :src="rewardInfo.icon" style="width: 66px" class="mb_6" />
            <div class="fs_16 mb_12">{{ rewardInfo.name }}</div>
            <div class="fs_12">礼包内容: {{ rewardInfo.desc }}</div>
          </div>
          <div class="f3_wrap fs_12">
            <div class="code_wrap flex_between mb_12">
              <div class="code_main">激活码：{{ rewardInfo.code }}</div>
              <div class="code_btn">
                <van-button
                  v-clipboard="rewardInfo.code"
                  round
                  size="mini"
                  color="#F84C4C"
                  style="width: 60px"
                  @click="handleCopyCode(feedbackType === 3 ? 7 : 10)"
                >复制</van-button>
              </div>
            </div>
            <p class="fs_12" style="color: #D62828">礼包有时间限制，请及时前往游戏中兑换</p>
          </div>
        </template>
      </Popup>
    </template>
    <div class="share-mask" v-if="showShare" @click="handleCloseShare">
      <img src="//image.hzwxbz2.cn/java-yunying/jyy_1724393215665_1cb53d3b7f3f4111ab09f03166c372c9.png" alt="">
      <p>点击右上角，发送给朋友或分享到朋友圈~</p>
    </div>
  </div>
</template>

<script>
import { Util } from 'xgplayer'
import { CDN_URL } from '@/config/index.js';
import VideoPlayer from '@/components/videoPlayer/index.vue'
import { Button, Swipe, SwipeItem, Popup as VanPopup } from 'vant'
import Popup from '@/components/activityComps/Popup.vue'
import Record from './record.vue'
import {
  signUpLotActInfo, signUpLotUserInfo,
  signUpLotGameList, signUpLotGetLog,
  signUpLotGameDetail, signUpLotGetChance,
  signUpLotGetGift, signUpLotLottery,
  rlaReportData,
} from '@/api/activity'
import BindAccountDialog from '@/components/CustomDialogs/BindAccountDialog.vue';
import { wxShareData } from '@/utils/wxinit';

const MAP_KEY = 'rla_token_map'

export default {
  components: {
    [Button.name]: Button,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [VanPopup.name]: VanPopup,
    VideoPlayer,
    Popup,
    BindAccountDialog,
    Record,
  },
  mounted () {
    this.handleHeaderInView()
    this.handleGetActInfo().then(res => {
      if (res) {
        this.handleGetGameList()
      }
    })
    this.handleFetchUserInfo()
    wxShareData()
  },
  data () {
    return {
      CDN_URL: CDN_URL + '/drawLot',
      icons: {
        startPlay: `<div><img style="width: 88px" src="${CDN_URL}/drawLot/play.png" /></div>`
      },
      showBindBtn: true, // 是否显示绑定按钮
      actionLoading: false, // 抽奖相关的 loading
      receiveLoading: false, // 领取奖品的 loading
      actInfo: {},
      recordFetched: false,
      visible: false,
      feedbackType: 1,
      bindingAccount: '',
      showBottonLine: false,
      curActiveSwipteItem: 0, // 当前轮播图的索引
      downloadUrl: '', // 游戏下载地址
      rewardInfo: {}, // 奖品信息
      gameList: [], // 游戏会场列表
      marqueeList: [],
      gameDetail: {
        register_welfare: {
          can_get: 1,
        },
      }, // 当前游戏会场详情
      curGameId: 0, // 当前游戏的id
      showRecord: false,
      showGiftDetail: false,
      showShare: false,
      recordList: [], // 中奖记录列表
      drawCount: 0, // 抽奖次数
      slogan: '', // 活动口号
      // 九宫格转盘配置参数
      prizes: [
        { x: 0, y: 0 },
        { x: 1, y: 0 },
        { x: 2, y: 0 },
        { x: 2, y: 1 },
        { x: 2, y: 2 },
        { x: 1, y: 2 },
        { x: 0, y: 2 },
        { x: 0, y: 1 },
      ],
      buttons: [
        {
          x: 1, y: 1,
          background: 'rgba(0,0,0,0)',
          fonts: [
            {
              text: '剩余     次',
              top: '72%',
              fontSize: '10px',
            },
            {
              text: '    1',
              top: '72%',
              fontSize: '10px',
              fontColor: '#ff2020',
            },
          ],
          imgs: [{
            src: CDN_URL + '/drawLot/draw_button.png',
            width: '80%',
            height: '80%',
            top: '10%',
          }],
        },
      ],
      extraAttrs: {
        defaultStyle: {
          background: 'transparent',
          fontSize: '14px',
          fontColor: '#fff',
        },
        activeStyle: {
          background: 'transparent'
        },
        // blocks: [
        //   { padding: '10px' },
        // ],
      },
    }
  },
  computed: {
    actId () {
      return this.$route.query.id
    },
    curGameInfo () {
      return this.gameList.find(item => item.register_draw_game_id === this.curGameId) || {}
    },
    feedback () {
      return this.feedbackMap[this.feedbackType] || {}
    },
    feedbackMap () {
      return [
        {
          title: '活动规则',
          message: [],
          showCancelButton: false,
          showConfirmButton: false,
          onCancel: () => {
            this.triggerVisible(false)
          },
          onSure: () => {
            this.triggerVisible(false)
          }
        },
        {
          title: '提示',
          message: [
            '此活动仅限新用户参与，',
            '去其他游戏会场看看吧'
          ],
          confirmButtonText: '我知道了',
          onCancel: () => {
            this.triggerVisible(false)
          },
          onSure: () => {
            this.triggerVisible(false)
          }
        },
        {
          title: '提示',
          message: [
            '领取礼包需激活对应游戏，',
            '下载并进入游戏即可激活'
          ],
          showCancelButton: true,
          confirmButtonText: '下载游戏',
          cancelButtonText: '再逛逛',
          onCancel: () => {
            this.triggerVisible(false)
          },
          onSure: () => {
            this.EVENT_TRACK(7, {
              gift_id: this.gameDetail.register_welfare.gift_id,
              gift_popup_btn_2: 1,
            })
            this.handleOpenNewPage(this.downloadUrl)
            this.triggerVisible(false)
          }
        },
        {
          title: '领取成功',
          message: [],
          confirmButtonText: '确认',
          onCancel: () => {
            this.triggerVisible(false)
          },
          onSure: () => {
            this.triggerVisible(false)
          }
        },
        {
          title: '中奖结果',
          message: [],
          confirmButtonText: '确认',
          onCancel: () => {
            this.triggerVisible(false)
          },
          onSure: () => {
            this.triggerVisible(false)
          }
        },
      ]
    },
  },
  methods: {
    handleShare (id) {
      this.showShare = true
      this.EVENT_TRACK(13, {
        register_draw_welfare_task_id: id
      })
    },
    handleShowGiftDetail() {
      this.showGiftDetail = true
      this.EVENT_TRACK(12)
    },
    // 获取活动详情
    handleGetActInfo () {
      if (!this.actId) return this.$toast.fail('活动已失效')
      return signUpLotActInfo(this.actId).then(res => {
        const { data, code } = res
        if (data.title) {
          this.actInfo = data
          document.title = this.actInfo.title || '注册得好礼'
        } else {
          this.$toast.fail('活动已失效')
        }
        this.EVENT_TRACK(1)
        return !!data.title
      })
    },
    // 获取用户信息
    handleFetchUserInfo (rlaTokenStr) {
      if (rlaTokenStr) {
        this.setRlaToken(rlaTokenStr)
        this.handleGetActInfo().then(res => {
          if (res) {
            this.handleGetGameList(this.curGameInfo)
          }
        })
      }
      signUpLotUserInfo(this.actId).then(res => {
        // 缓存用户信息
        const { code, data } = res
        if (data) {
          this.bindingAccount = data.game_account
        }
      }).finally(() => {
        this.validateBinding(false)
      })
    },
    // 获取游戏会场列表
    handleGetGameList (game) {
      signUpLotGameList(this.actId).then(res => {
        const { code, data } = res
        if (code === 1) {
          this.gameList = data || []
          if (data.length) {
            this.handleChangeGame((game) ? game : data[0])
          }
        }
      })
    },
    giftDetailCloseReport() {
      this.EVENT_TRACK(14)
    },
    handleCloseShare() {
      this.showShare = false
      this.EVENT_TRACK(15)
    },
    // 选择某一个游戏会场
    handleChangeGame (game) {
      const { register_draw_game_id } = game
      this.curGameId = register_draw_game_id
      this.recordList = []
      this.recordFetched = false
      // 迫使视频更新
      this.getFieldInDetail('video')[0] = ''
      this.handleGetGameDetail()
      this.EVENT_TRACK(2)
    },
    // 获取当前游戏会场的详情
    handleGetGameDetail (isInitLucky = true) {
      signUpLotGameDetail({
        id: this.actId,
        register_draw_game_id: this.curGameId,
      }).then(res => {
        console.log('game detail-->', res)
        const { data, code } = res
        const { surplus_lottery_times, lottery_list, download_url, slogan } = data
        this.drawCount = surplus_lottery_times
        this.downloadUrl = download_url
        this.buttons[0].fonts[1].text = '    ' + surplus_lottery_times
        this.gameDetail = data
        this.slogan = slogan
        // 有些场景无需刷新转盘
        if (isInitLucky) {
          this.initLucky()
        }
      })
    },
    // 初始化转盘
    initLucky () {
      const list = this.gameDetail.lottery_list || []
      if (!list.length) return

      const gift = list.map(it => it.name);
      this.marqueeList = Array.from({ length: 15 }).map(() => {
        return {
          name: gift[Math.floor(Math.random() * gift.length)],
          userName: this.randomString()
        }
      })
      console.log('marqueeList-->', this.marqueeList)
      
      this.prizes = this.prizes.map((it, idx) => {
        const curPosi = list[idx]
        if (!curPosi) return
        const { id, name, icon } = curPosi
        it.imgs = [
          { src: this.CDN_URL + '/block.png', activeSrc: this.CDN_URL + '/block_active.png', width: '100%', height: '100%' },
          { src: icon, width: '100%', top: '0%' },
        ]
        it.fonts = [{
          text: name,
          top: '0.96rem',
          fontColor: '#340606',
        }]
        return it
      })
    },
    randomString() {
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      // 生成一个长度为 8 的随机字母+数字组合的字符串
      let accountName = '';
      for (let i = 0; i < 8; i++) {
        accountName += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      
      // 将第 4-7 位替换为 *
      const maskedAccountName = accountName.slice(0, 3) + '****' + accountName.slice(7);

      return maskedAccountName;
    },
    getFieldInDetail (field) {
      return this.gameDetail[field] || []
    },
    // 领取奖励
    handleReceiveReward (it = {}) {
      if (!this.validateBinding()) return
      const { id, draw_count } = it
      if (this.actionLoading) return
      this.actionLoading = true
      signUpLotGetChance({
        id: this.actId,
        register_draw_game_id: this.curGameId,
        register_draw_welfare_task_id: id,
      }).then(res => {
        const { code, data, message } = res
        if (code === 1) {
          this.handleGetGameDetail()
          this.$toast.success('领取次数+' + draw_count)
        }
      }).catch(err => {
        this.handleCatchCode(err, id)
      }).finally(() => {
        this.actionLoading = false
      })
    },
    // 验证绑定关系
    validateBinding (autoTrigger = true) {
      console.log('vvvvalid')
      const tokenSet = JSON.parse(localStorage.getItem(MAP_KEY) || '{}')
      const CURRENT_KEY = `rlaToken${this.actId}`
      const token = tokenSet[CURRENT_KEY]
      const isValid = token && token.length && this.bindingAccount
      // 如果没有绑定，则弹出绑定框
      if (!isValid && autoTrigger) {
        this.triggerBindAccountDialog(true)
      }
      this.showBindBtn = !isValid
      return isValid
    },
    // 设置 rla_token
    setRlaToken (tokenStr) {
      const _KEY = 'rlaToken' + this.actId
      const tokenSet = JSON.parse(localStorage.getItem(MAP_KEY) || '{}')
      tokenSet[_KEY] = tokenStr
      localStorage.setItem(MAP_KEY, JSON.stringify(tokenSet))
    },
    // 创建 header 的是否在视口内的监听
    handleHeaderInView () {
      const item = document.querySelector("#header")
      const options = {
        // root: document.querySelector("#page_w"),
        rootMargin: "0px",
        threshold: [0, 0.5] ,
      };

      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          this.showBottonLine = entry.intersectionRatio === 0;
        });
      }, options); 
      observer.observe(item);
    },
    // 一键领取
    handleReceive () {
      if (!this.validateBinding()) return
      const { gift_id, can_get, code } = this.gameDetail.register_welfare || {}
      // 已领取状态, 直接提示弹窗
      if (can_get === 0) {
        this.rewardInfo = {
          code,
        }
        this.triggerVisible(true, 3)
        return
      }
      if (this.receiveLoading) return
      this.receiveLoading = true
      signUpLotGetGift({
        id: this.actId,
        register_draw_game_id: this.curGameId,
      }).then(res => {
        const { data } = res
        this.rewardInfo = {
          code: data.code,
        }
        this.handleGetGameDetail(false)
        this.triggerVisible(true, 3)
        this.EVENT_TRACK(6, {
          gift_popup_btn_1: 3,
          gift_id,
        })
      }).catch(err => {
        this.handleCatchCode(err, gift_id)
      }).finally(() => {
        this.receiveLoading = false
      })
    },
    handleCatchCode (err, gift_id) {
      const { code, data, message } = err
      // 未下载游戏
      if (code === 101) {
        this.triggerVisible(true, 2)
        this.EVENT_TRACK(6, {
          gift_popup_btn_1: 2,
          gift_id,
        })
        return
      }
      // 不满足活动条件
      if (code === 102) {
        this.triggerVisible(true, 1)
        this.EVENT_TRACK(6, {
          gift_popup_btn_1: 1,
          gift_id,
        })
        return
      }
      if (code === 0) {
        this.$toast.fail(message)
      }
    },
    onluckyStart () {
      console.log('start')
      // 判断绑定账号
      if (!this.validateBinding()) return
      // 判断抽奖次数
      if (!this.drawCount) {
        this.$toast('没有抽奖机会了，请查看下方任务获取抽奖次数')
        return
      }
      if (this.actionLoading) return
      this.actionLoading = true
      signUpLotLottery({
        id: this.actId,
        register_draw_game_id: this.curGameId,
      }).then(res => {
        const { data = {} } = res
        const { id, code, desc, type } = data
        const { lottery_list = [] } = this.gameDetail
        const idx = lottery_list.findIndex(it => it.id === id)
        const { icon, name } = lottery_list[idx] || {}
        // 记录当前抽中奖品信息
        this.rewardInfo = {
          ...data,
          icon,
          name,
        }
        this.$refs.luckyGrid.play()
        this.handleGetGameDetail(false)
        // accelerationTime[2500] + decelerationTime[2500] = 5000
        setTimeout(() => {
          this.$refs.luckyGrid.stop(idx)
          setTimeout(() => {
            if (type === 0) {
              this.$toast.fail('礼包码已领完，请联系客服补发')
              return
            }
            this.triggerVisible(true, 4)
            this.EVENT_TRACK(9)
            this.actionLoading = false
            this.initLucky()
            // 留 800ms 的滞空时间
          }, 5000 - 1000 + 800)
        }, 1000)
      }).catch(err => {
        const { message } = err
        this.$toast.fail(message)
        this.actionLoading = false
        this.initLucky()
      })
    },
    onluckyEnd () {},
    handleShowRule () {
      this.triggerVisible(true, 0)
    },
    handleOpenRecord () {
      if (!this.validateBinding()) return
      this.showRecord = true
      this.handleGetRecords()
    },
    triggerVisible (v, type) {
      if (type !== undefined) {
        this.feedbackType = type
      }
      this.visible = v
    },
    handleSwipeChange (e) {
      // console.log('current index-->', e)
      this.curActiveSwipteItem = e
    },
    handleGetRecords () {
      signUpLotGetLog({
        id: this.actId,
        register_draw_game_id: this.curGameId,
      }).then(res => {
        console.log('records-->', res)
        this.recordList = res.data || []
        this.recordFetched = true
      })
    },
    handleBotBtnClick () {
      this.EVENT_TRACK(11, {
        bottom_btn: 2,
      })
      this.handleOpenNewPage(this.downloadUrl)
    },
    handleHeaderDownload () {
      this.EVENT_TRACK(3)
      this.handleOpenNewPage(this.downloadUrl)
    },
    handleOpenNewPage (url) {
      // 是否校验 url 的合法性
      window.open(url, '_blank')
    },
    handldShowBinding () {
      this.EVENT_TRACK(11, {
        bottom_btn: 1,
      })
      this.triggerBindAccountDialog(true)
    },
    // 复制礼包码的埋点
    handleCopyCode (type) {
      this.EVENT_TRACK(type, {
        gift_id: type === 7 ? this.gameDetail.register_welfare.gift_id : undefined,
        gift_popup_btn_2: 2,
      })
    },
    EVENT_TRACK (data_type, params = {}) {
      rlaReportData({
        type: 20, // 本活动
        data_type,
        overall_id: this.actId,
        game_venue_id: this.curGameId,
        ...params,
      })
    },
    triggerBindAccountDialog (flag) {
      if (this.$refs.bindAccountRef) {
        this.$refs.bindAccountRef.triggerVisible(flag);
      }
    },
    // 绑定用户新逻辑
    onLogswitch () {
      this.triggerBindAccountDialog(true)
    },
  },
}
</script>

<style lang="scss" scoped>
@import './style.scss';
::v-deep .xgplayer-start {
  width: 88px !important;
  height: 88px !important;
}
.custom-indicator {
  display: flex;
  justify-content: center;
  align-items: center;
  .indi_item {
    width: 12px;
    height: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    .indi_dot {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: #D6D6D6;
    }
  }
  .indi_active {
    border: 1px solid #fff;
    .indi_dot {
      background-color: #fff;
    }
  }
  .indi_item + .indi_item {
    margin-left: 4px;
  }
}
.f3_wrap {
  .code_wrap {
    padding: 8px 12px;
    background-color: #F3F3F3;
    border-radius: 6px;
  }
}
.gift-detail-item {
  width: 90%;
  height: 100%;
  overflow: auto;
  margin: auto;
  padding-top: 27px;
  position: relative;
  padding-bottom: 80px;
  .gift-title {
    text-align: center;
    width: 100%;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 24px;
  }
  .gift-list {
    width: 100%;
    .gift-item {
      width: 100%;
      padding-bottom: 13px;
      margin-bottom: 7px;
      position: relative;
      &::after {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        content: '';
        display: block;
        width: 80%;
        height: 1px;
        background: #d7d7d7;
        margin: auto;
      }
      > p {
        font-size: 14px;
        margin-bottom: 10px;
        font-weight: 500;
        text-align: left;
        color: #000000;
      }
      .gift-info {
        display: flex;
        > img {
          width: 51px;
          height: 51px; 
          margin-right: 12px;
          border-radius: 6px;
        }
        > div {
          .gift-name {
            font-size: 13px;
            font-weight: bold;
            color: #333;
            margin-bottom: 5px;
          }
          .gift-desc {
            font-size: 13px;
            color: #646464;
            line-height: 1.5;
          }
        }
      }
    }

  }
  .gift-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 100%;
    text-align: center;
    height: 70px;
    padding-top: 20px;
    background: #fff;
    button {
      border: none;
      width: 178.82px;
      height: 37.85px;
      background: #e93f11;
      font-size: 13px;
      color: #fff;
      border-radius: 20px;
    }
  }
}
.share-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.57);
  z-index: 999;
  > img {
    width: 73.26px;
    height: 45.49px;
    position: absolute;
    top: 10px;
    right: 30px;
  }
  > p {
    position: absolute;
    top: 70px;
    left: 0;
    right: 0;
    text-align: center;
    font-size: 15px;
    color: #fff;
  }
}
.tips {
  width: 313px;
  height: 62px;
  margin: 4px auto 0;
  background-image: url('https://assets.hzwxbz2.cn/sy/hm_act/img/tip_bg_line_1.png');
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
}
.tips_main {
  font-size: 12px;
  line-height: 1.64;
  color: #FFD096dd;
  text-align: center;
  white-space: pre-wrap;  
  padding-top: 26px;
}
.tips_main_line_2 {
  background-image: url('https://assets.hzwxbz2.cn/sy/hm_act/img/tip_bg_line_2.png');
  height: 84px;
  .tips_main {
    padding-top: 30px;
  }
}
</style>
